import { createBrowserHistory } from "history";
export const crmHistory = createBrowserHistory<Record<string, never>>();
export const push = (path: string, state?: Record<string, never>) =>
    crmHistory.push(path, state);
